/**
 * @author Trendrating <info@trendrating.net>
 *
 * @module api/account/Sessions
 * @summary Requests for sessions
 *
 */

import { endpoints } from "../endpoints";
import { _Base } from "../_Base";
import { decodeUser } from "./Decoder";

export class Sessions extends _Base {
  /**
   * Checks if the current session is valid or expired
   */
  async isValid() {
    const endPointRoot = process.env.REACT_APP_ROOT_T_REST;
    const url = endPointRoot + endpoints.accounts.sessions.get;

    const response = await this.prepareGet(url, {
      testget: "check",
    });

    let permissions: any = null;
    if (response.status === "OK") {
      permissions = await this.getUserPermissions(
        parseInt(response.data.user.id),
        null
      );
    }
    let userDecoded = decodeUser(response);
    if (permissions.data.permissions.length != null) {
      userDecoded["permissions"] = permissions.data.permissions;
    }
    return userDecoded;
  }

  async getUserPermissions(userID: number, headers) {
    const endPointRoot = process.env.REACT_APP_ROOT_T_REST;
    const url = endPointRoot + endpoints.accounts.users.getUserPermissions;
    const params = { userId: userID };
    const response = await this.prepareGet(url, params, headers);
    return response;
  }

  async logout() {
    const endPointRoot = process.env.REACT_APP_ROOT_T_REST;
    const url = endPointRoot + endpoints.accounts.sessions.remove;

    const response = await this.prepareGet(url, null);

    return response;
  }
}
